export const loadLang = chunk => {
  switch (chunk) {
    case 'en':
      return import('@/i18n/lang/en')
    case 'ru':
      return import(
        /* webpackChunkName: "ru" */
        '@/i18n/lang/ru'
      )
    case 'uk':
      return import(
        /* webpackChunkName: "uk" */
        '@/i18n/lang/uk'
      )
    case 'pl':
      return import(
        /* webpackChunkName: "pl" */
        '@/i18n/lang/pl'
      )
    case 'sk':
      return import(
        /* webpackChunkName: "sk" */
        '@/i18n/lang/sk'
      )
    case 'cs':
      return import(
        /* webpackChunkName: "cs" */
        '@/i18n/lang/cs'
      )
  }
}

export const Vue = () =>
  import(/* webpackChunkName: "1" */ 'vue').then(module => module.default)

export const App = () =>
  import(/* webpackChunkName: "2" */ '@/App').then(module => module.default)

export const installStore = () =>
  import(/* webpackChunkName: "3" */ '@/store/setup').then(
    ({ installStore }) => installStore
  )

export const installValidate = () =>
  import(/* webpackChunkName: "4" */ '@/validate').then(
    ({ installValidate }) => installValidate
  )

export const i18n = () =>
  import(/* webpackChunkName: "5" */ '@/i18n').then(({ i18n }) => i18n)

export const focusVisible = () =>
  import(/* webpackChunkName: "6" */ 'focus-visible')

export const routerDonations = () =>
  import(/* webpackChunkName: "7" */ '@/router/donations').then(
    ({ router }) => router
  )

export const storeDonations = () =>
  import(/* webpackChunkName: "8" */ '@/store/donations').then(
    ({ store }) => store
  )

export const LDonations = () =>
  import(/* webpackChunkName: "9" */ '@/views/LDonations')

export const LDonationsStart = () =>
  import(/* webpackChunkName: "10" */ '@/views/donations/LDonationsStart')

export const LDonationsPay = () =>
  import(/* webpackChunkName: "11" */ '@/views/donations/LDonationsPay')

export const LDonationsCheckout = () =>
  import(/* webpackChunkName: "12" */ '@/views/donations/LDonationsCheckout')

export const routerProducts = () =>
  import(/* webpackChunkName: "13" */ '@/router/products').then(
    ({ router }) => router
  )

export const storeProducts = () =>
  import(/* webpackChunkName: "14" */ '@/store/products').then(
    ({ store }) => store
  )

export const LProducts = () =>
  import(/* webpackChunkName: "15" */ '@/views/LProducts')

export const LProductsStart = () =>
  import(/* webpackChunkName: "16" */ '@/views/products/LProductsStart')

export const LProductsCheckout = () =>
  import(/* webpackChunkName: "17" */ '@/views/products/LProductsCheckout')

export const routerDigitalGoods = () =>
  import(/* webpackChunkName: "18" */ '@/router/digital-goods').then(
    ({ router }) => router
  )

export const storeDigitalGoods = () =>
  import(/* webpackChunkName: "19" */ '@/store/digital-goods').then(
    ({ store }) => store
  )

export const LDigitalGoods = () =>
  import(/* webpackChunkName: "20" */ '@/views/LDigitalGoods')

export const LDigitalGoodsStart = () =>
  import(
    /* webpackChunkName: "21" */ '@/views/digital-goods/LDigitalGoodsStart'
  )

export const LDigitalGoodsCheckout = () =>
  import(
    /* webpackChunkName: "22" */ '@/views/digital-goods/LDigitalGoodsCheckout'
  )

export const LServices = () =>
  import(/* webpackChunkName: "23" */ '@/views/digital-goods/LServices')

export const L404 = () => import(/* webpackChunkName: "24" */ '@/views/L404')

export const routerCreate = () =>
  import(/* webpackChunkName: "25" */ '@/router/create').then(
    ({ router }) => router
  )

export const storeCreate = () =>
  import(/* webpackChunkName: "26" */ '@/store/create').then(
    ({ store }) => store
  )

export const LCreate = () =>
  import(/* webpackChunkName: "27" */ '@/views/LCreate')
